import { Box, Card, Typography } from "@mui/material";
import { Constants } from "../constants";
import { CustomTooltip } from "../utils/CustomTooltip";
import CustomDivider from "../utils/CustomDivider";

const CompetitionResultCard = () => {
    return (

        <>
            <Box sx={{ textAlign: 'center', width: '100%', mt: 2 }}>
                <Typography variant="body1" component={"span"} fontWeight={300} sx={{ borderBottom: "1px solid #000", py: 1, px: 3 }} >
                    Grand Prize Winner | Ravi  By Monaj
                </Typography>

            </Box>


            <CustomDivider size={"2rem"} />
            <Box sx={{ display: 'flex', height: "350px" }}>

                <Card
                    sx={{
                        width: "50%",
                        height: "100%",
                        position: 'relative',
                        borderTopLeftRadius: '1rem',
                        borderBottomLeftRadius: '1rem',

                        overflow: 'hidden',
                        backgroundImage: `url(${Constants.customImages.ResultCandidateImg})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}
                >
                    <Box sx={{ position: 'absolute', top: 8, left: 8 }}>
                        <CustomTooltip number={`${200} votes`} icon="material-symbols:thumb-up-rounded" />
                    </Box>
                </Card>



                <Card
                    sx={{
                        width: "50%",
                        height: "100%",
                        backgroundImage: `url(${Constants.customImages.ResultShirtImg})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        borderTopRightRadius: '1rem',
                        borderBottomRightRadius: '1rem',

                    }}
                />

            </Box>
            <CustomDivider size={"2rem"} />
        </>

    );
};

export default CompetitionResultCard;

